import { useEffect, useRef, useState } from "react";

const useInView = (threshold = 0.08) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          obs.disconnect();
        }
      },
      { threshold, rootMargin: "0px 0px -8% 0px" }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, inView];
};

// CSS-transition reveal (compositor-driven — reliable everywhere).
export const Reveal = ({ children, delay = 0, className = "", as: Tag = "div", ...rest }) => {
  const [ref, inView] = useInView();
  return (
    <Tag
      ref={ref}
      className={`reveal ${inView ? "in" : ""} ${className}`}
      style={{ transitionDelay: `${delay}s` }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

// Masked line-by-line reveal via CSS.
export const MaskedLines = ({ lines = [], className = "", lineClassName = "", start, delay = 0, stagger = 0.09 }) => {
  const [ref, inView] = useInView(0.2);
  const active = start !== undefined ? start : inView;
  return (
    <span ref={ref} className={className}>
      {lines.map((line, i) => (
        <span key={i} className={`mask-line ${active ? "in" : ""}`}>
          <span className={lineClassName} style={{ transitionDelay: `${delay + i * stagger}s` }}>
            {line}
          </span>
        </span>
      ))}
    </span>
  );
};
